<template>
    <b-row>
        <b-col cols="0" v-if="!plazos">
            <Button
                :label="$t('bases.pago_plazos')"
                :disabled="disabled"
                custom-class="ml-3"
                data-cy="pago-plazos"
                @click="show_modal = true"
            />
        </b-col>
        <b-col cols="0" v-else>
            <Button
                :label="$t('bases.importe_completo')"
                :disabled="disabled"
                custom-class="mr-2"
                @click="reset()"
            />
            <Button
                :label="$t('bases.modificar_plazos')"
                :disabled="disabled"
                @click="show_modal = true"
            />
        </b-col>
        <b-col cols="12" v-if="error_plazos">
            <b-alert
                class="mt-3"
                :show="error_plazos"
                variant="danger"
            >
                No es posible fraccionar los plazos de pago con fecha superior a fecha {{ teatro.fecha_limite_plazos }}
            </b-alert>
        </b-col>

        <b-modal
            size="lg"
            centered
            :hide-footer="true"
            v-model="show_modal"
            :title="$t('bases.activar_plazos')"
        >
            <b-row>
                <b-col cols="12">
                    <p>{{ $t('bases.texto_plazos') }}</p>
                </b-col>
                <b-col cols="12">
                    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
                        <b-row>
                            <b-col md="6" sm="12">
                                <ValidationProvider name="cuotas" id='cuotas' rules="required" class="mr-2" v-slot="{ errors }">
                                    <multiselect
                                        v-model="data.plazoSelect"
                                        data-cy="cuotas"
                                        id='cuotas-input'
                                        :placeholder="$t('bases.cantidad_disponible')"
                                        :options="cuotas"
                                        :show-labels="false"
                                        :max-height="150"
                                    />
                                    <span v-if="errors[0]" class="error invalid-feedback alert-danger white p-1" style="display: block">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </b-col>
                            <b-col md="6" sm="12">
                                <ValidationProvider v-if="frecuencias.length > 0" name="frecuencia" id='frecuencia' rules="required" v-slot="{ errors }">
                                    <multiselect
                                        v-model="data.frecuenciaSelect"
                                        data-cy="frecuencias"
                                        id='frecuencias-input'
                                        label="frecuencia_formatted"
                                        track-by="id"
                                        :placeholder="$t('bases.frecuencia_disponible')"
                                        :options="frecuencias"
                                        :show-labels="false"
                                        :max-height="150"
                                    />
                                    <span v-if="errors[0]" class="error invalid-feedback alert-danger white p-1" style="display: block">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </b-col>
                        </b-row>
                        <b v-if="tiene_gastos"><p>{{ $t('bases.aviso_gd', {gd: gastos}) }}</p></b>
                        <div class="mt-3">
                            <Button
                                type="button"
                                :label="$t('formularios.continuar')"
                                :disabled="disabled"
                                custom-class="mr-2"
                                data-cy="confirmar-plazos"
                                @click="terminar()"
                            />
                            <Button
                                type="button"
                                :label="$t('formularios.atras')"
                                :disabled="disabled"
                                @click="show_modal = false"
                            />
                        </div>
                    </ValidationObserver>
                </b-col>
            </b-row>
        </b-modal>
    </b-row>
</template>

<script setup>
    import { ref, computed, watch } from 'vue';
    import store from '@/store';
    import Button from '@/modules/ui/Button.vue';

    const props = defineProps({
        frecuencias: { type: Array, required: true },
        min_plazos: { type: Number, required: true },
        max_plazos: { type: Number, required: true },
        gastos: { type: Number, required: true },
        error_plazos: { type: Boolean, default: false },
        tiene_gastos: { type: Boolean, required: true },
        disabled: { type: Boolean, default: false },
        plazosActivo: { type: Boolean, default: undefined }
    });

    const emit = defineEmits(['terminado', 'reset']);

    const data = ref({});
    const show_modal = ref(false);
    const plazos = ref(false);

    watch(() => props.plazosActivo, val => {
        if (val !== undefined) {
            plazos.value = val;
        }
    }, { immediate: true });
    const observer = ref(null);

    const cuotas = computed(() => {
        const result = [];
        for (let i = props.min_plazos; i <= props.max_plazos; i++) {
            result.push(i);
        }
        return result;
    });

    const teatro = computed(() => store.getters.getTeatro);

    watch(show_modal, () => {
        data.value = {};
    });

    const terminar = async() => {
        const isValid = await observer.value.validate();
        if (isValid) {
            plazos.value = true;
            show_modal.value = false;
            emit('terminado', data.value);
        }
    };

    const reset = () => {
        plazos.value = false;
        emit('reset');
    };
</script>
